document.addEventListener('alpine:init', () => {
    Alpine.data('membershipHandler', () => ({
        // ---- Data ----
        user_id: null,
        renewal_url: '',
        wc_nonce: '',
        member_number: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).member_number || '' : '',
        social_security_number: sessionStorage.getItem('wizardFormData')
            ? JSON.parse(sessionStorage.getItem('wizardFormData')).social_security_number || ''
            : '',
        billing_first_name: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).billing_first_name || '' : '',
        billing_last_name: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).billing_last_name || '' : '',
        billing_email: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).billing_email || '' : '',
        billing_phone: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).billing_phone || '' : '',
        billing_address_1: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).billing_address_1 || '' : '',
        billing_postcode: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).billing_postcode || '' : '',
        billing_city: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).billing_city || '' : '',
        has_paper: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).has_paper ?? 1 : 1,
        main_member: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).main_member || '' : '',
        //familyMembers: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).familyMembers || [] : [],
        is_family_member: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).is_family_member || false : false,
        has_already_paid: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).has_already_paid || false : false,
        has_subscription: sessionStorage.getItem('wizardFormData') ? JSON.parse(sessionStorage.getItem('wizardFormData')).has_subscription || false : false,

        familyMembers: (() => {
            const data = sessionStorage.getItem('wizardFormData');
            if (!data) {
                return [];
            }
            const parsed = JSON.parse(data);
            if (!parsed.familyMembers) {
                return [];
            }
            return parsed.familyMembers.map(member => ({
                id: member.id,
                first_name: member.first_name,
                last_name: member.last_name,
            }));
        })(),

        currentStep: sessionStorage.getItem('wizardCurrentStep') ? parseInt(sessionStorage.getItem('wizardCurrentStep'), 10) : 0,
        errorMessage: '',
        isLoading: false,
        dialog_already_paid: false,
        dialog_family_member: false,
        dialog_no_subscription: false,

        // ---- Step 1 error messages and flags ----
        memberNumberError: '',
        billingPostcodeError: '',
        memberNumberValid: false,
        billingPostcodeValid: false,
        socialSecurityNumberTouched: false,

        // ---- Step 2 error messages and flags ----
        billingFirstNameError: '',
        billingLastNameError: '',
        socialSecurityNumberError: '',
        billingEmailError: '',
        billingPhoneError: '',
        billingAddressError: '',
        billingCityError: '',
        billingFirstNameValid: false,
        billingLastNameValid: false,
        socialSecurityNumberValid: false,
        billingEmailValid: false,
        billingPhoneValid: false,
        billingAddressValid: false,
        billingCityValid: false,

        // ---- Init method to load step and field values from sessionStorage ----
        init() {

            // ---- Recreate step ----
            const savedStep = sessionStorage.getItem('wizardCurrentStep');
            if (savedStep !== null) {
                this.currentStep = parseInt(savedStep, 10);
            }

            // ---- Recreate values ----
            const savedFields = JSON.parse(sessionStorage.getItem('wizardFormData') || '{}');
            Object.keys(savedFields).forEach(key => {
                if (this.hasOwnProperty(key) && savedFields[key] !== undefined) {
                    this[key] = savedFields[key];
                }
            });

            // ---- Update tabs after current step ----
            this.$nextTick(() => {
                const tabs = document.querySelectorAll('.progress-tabs .tab');
                const contents = document.querySelectorAll('.tab-content');
                tabs.forEach((tab, i) => tab.classList.toggle('active', i === this.currentStep));
                contents.forEach((content, i) => content.classList.toggle('hidden', i !== this.currentStep));
            });

            // ---- Listen for changes and update fields ----
            this.$watch('$data', (value) => {
                const fieldsToSave = {
                    billing_first_name: value.billing_first_name,
                    billing_last_name: value.billing_last_name,
                    social_security_number: value.social_security_number,
                    billing_email: value.billing_email,
                    billing_phone: value.billing_phone,
                    billing_address_1: value.billing_address_1,
                    billing_postcode: value.billing_postcode,
                    billing_city: value.billing_city,
                    has_paper: value.has_paper,
                    member_number: value.member_number,
                    main_member: value.main_member,
                    familyMembers: value.familyMembers,
                    is_family_member: value.is_family_member,
                    has_already_paid: value.has_already_paid,
                    has_subscription: value.has_subscription,
                };
                sessionStorage.setItem('wizardFormData', JSON.stringify(fieldsToSave));
            });
        },

        // ---- Navigation methods ----
        goToStep(stepIndex) {
            if (this.has_already_paid && this.is_family_member && (stepIndex === 2 || stepIndex === 3)) {
                this.goToStep(1);
                this.dialog_family_member = true;
                return;
            } else if (this.is_family_member && (stepIndex === 2 || stepIndex === 3)) {
                this.goToStep(1);
                this.dialog_family_member = true;
                return;
            } else if (this.has_already_paid && (stepIndex === 2 || stepIndex === 3)) {
                this.goToStep(1);
                this.dialog_already_paid = true;
                return;
            } else if (!this.has_subscription && (stepIndex === 2 || stepIndex === 3)) {
                this.goToStep(1);
                this.dialog_no_subscription = true;
                return;
            }

            this.currentStep = stepIndex;
            if (stepIndex !== 3) {
                sessionStorage.setItem('wizardCurrentStep', stepIndex);
            }
            this.errorMessage = '';

            const tabs = document.querySelectorAll('.progress-tabs .tab');
            const contents = document.querySelectorAll('.tab-content');
            tabs.forEach((tab, i) => tab.classList.toggle('active', i === stepIndex));
            contents.forEach((content, i) => content.classList.toggle('hidden', i !== stepIndex));
        },

        goToStepIfAllowed(index) {
            if (index <= this.currentStep) {
                this.goToStep(index);
            }
        },

        tabClass(index) {
            if (this.currentStep === index) {
                return 'active';
            }
            if (index < this.currentStep) {
                return 'visited';
            }
            return 'next';
        },

        // ---- goBack method ----
        async goBack() {
            if (this.currentStep > 0) {
                this.goToStep(this.currentStep - 1);
                sessionStorage.setItem('wizardCurrentStep', this.currentStep);
            }
        },

        handleKeydown(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                if (this.currentStep === 3) {
                    this.updateMembership();
                } else if (this.currentStep === 2) {
                    this.updateUser();
                } else {
                    this.fetchUser();
                }
            }
        },

        setFieldValidity(fieldName, isValid) {
            const input = document.querySelector(`[name="${fieldName}"]`);
            if (input) {
                input.classList.toggle('valid-value', isValid);
            }
        },

        validateField(fieldName) {
            switch (fieldName) {
                case 'member_number':
                    this.validateMemberNumber();
                    break;
                case 'billing_postcode':
                    this.validateBillingPostcode();
                    break;
                case 'billing_first_name':
                    this.validateFirstName();
                    break;
                case 'billing_last_name':
                    this.validateLastName();
                    break;
                case 'social_security_number':
                    this.validateSocialSecurityNumber();
                    break;
                case 'billing_email':
                    this.validateEmail();
                    break;
                case 'billing_phone':
                    this.validatePhone();
                    break;
                case 'billing_address_1':
                    this.validateAddress();
                    break;
                case 'billing_city':
                    this.validateCity();
                    break;
            }
        },

        // ---- Step 1 validation ----
        validateMemberNumber() {
            this.member_number = this.member_number.replace(/\D/g, '');
            if (this.member_number.length > 7) {
                this.memberNumberError = 'Felaktigt format på medlemsnummer';
                this.memberNumberValid = false;
            } else if (this.member_number.length === 7) {
                this.memberNumberError = '';
                this.memberNumberValid = true;
            } else {
                this.memberNumberValid = false;
                this.memberNumberError = '';
            }
            this.setFieldValidity('member_number', this.memberNumberValid);
        },

        validateBillingPostcode() {
            this.billing_postcode = this.billing_postcode.trim();

            if (this.billing_postcode !== '') {
                this.billingPostcodeError = '';
                this.billingPostcodeValid = true;
            } else {
                this.billingPostcodeError = 'Postnumret får inte vara tomt';
                this.billingPostcodeValid = false;
            }

            this.setFieldValidity('billing_postcode', this.billingPostcodeValid);
        },

        // validateBillingPostcode() {
        //     this.billing_postcode =
        //         this.billing_postcode.replace(/[^\d\s]/g, '');
        //
        //     const validFormat = /^(\d{5}|\d{3}\s\d{2})$/;
        //
        //     if (validFormat.test(this.billing_postcode)) {
        //         this.billingPostcodeError = '';
        //         this.billingPostcodeValid = true;
        //     } else {
        //         if (this.billing_postcode.length > 5) {
        //             this.billingPostcodeError =
        //                 'Felaktigt format på postnummer';
        //             this.billingPostcodeValid = false;
        //         } else {
        //             this.billingPostcodeError = '';
        //             this.billingPostcodeValid = false;
        //         }
        //     }
        //
        //     this.setFieldValidity(
        //         'billing_postcode',
        //         this.billingPostcodeValid,
        //     );
        // },

        // ---- Step 2 validation ----
        validateFirstName() {
            this.billingFirstNameValid = !!this.billing_first_name.trim();
            this.billingFirstNameError = this.billingFirstNameValid ? '' : 'Förnamn är obligatoriskt';
            this.setFieldValidity('billing_first_name', this.billingFirstNameValid);
        },

        validateLastName() {
            this.billingLastNameValid = !!this.billing_last_name.trim();
            this.billingLastNameError = this.billingLastNameValid ? '' : 'Efternamn är obligatoriskt';
            this.setFieldValidity('billing_last_name', this.billingLastNameValid);
        },

        validateSocialSecurityNumber() {
            let numbersOnly = this.social_security_number.replace(/\D/g, '');
            if (numbersOnly.length > 8) {
                numbersOnly = numbersOnly.slice(0, 8) + '-' + numbersOnly.slice(8, 12);
            }
            this.social_security_number = numbersOnly;
            this.socialSecurityNumberValid = /^\d{8}-\d{4}$/.test(this.social_security_number);
            this.socialSecurityNumberError = this.socialSecurityNumberValid ? '' : 'Felaktigt format på personnummer';
            this.setFieldValidity('social_security_number', this.socialSecurityNumberValid);
        },

        validateEmail() {
            this.billingEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.billing_email.trim());
            this.billingEmailError = this.billingEmailValid ? '' : 'Felaktigt format på e-post';
            this.setFieldValidity('billing_email', this.billingEmailValid);
        },

        validatePhone() {
            this.billingPhoneValid = !!this.billing_phone.trim();
            this.billingPhoneError = this.billingPhoneValid ? '' : 'Telefonnummer är obligatoriskt';
            this.setFieldValidity('billing_phone', this.billingPhoneValid);
        },

        validateAddress() {
            this.billingAddressValid = !!this.billing_address_1.trim();
            this.billingAddressError = this.billingAddressValid ? '' : 'Adress är obligatoriskt';
            this.setFieldValidity('billing_address_1', this.billingAddressValid);
        },

        validateCity() {
            this.billingCityValid = !!this.billing_city.trim();
            this.billingCityError = this.billingCityValid ? '' : 'Ort är obligatoriskt';
            this.setFieldValidity('billing_city', this.billingCityValid);
        },

        // ---- Step 1: fetch user ----
        async fetchUser() {
            this.isLoading = true;
            this.errorMessage = '';
            this.validateMemberNumber();
            this.validateBillingPostcode();

            if (!this.member_number) {
                this.memberNumberError = 'Medlemsnummer är obligatoriskt';
            }
            if (!this.billing_postcode) {
                this.billingPostcodeError = 'Postnummer är obligatoriskt';
            }
            if (this.member_number && this.member_number.length < 7) {
                this.memberNumberError = 'Felaktigt format på medlemsnummer';
            }
            // if (this.billing_postcode && this.billing_postcode.length < 5) {
            //     this.billingPostcodeError = 'Felaktigt format på postnummer';
            // }

            if (this.memberNumberError || this.billingPostcodeError) {
                this.isLoading = false;
                return;
            }

            try {
                const response = await fetch(wpAjax.ajax_url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: new URLSearchParams({
                        action: 'fetch_user',
                        member_number: this.member_number,
                        billing_postcode: this.billing_postcode,
                    }),
                });

                const data = await response.json();

                console.log('data: ', data);

                if (data.posts && data.posts.length > 0) {
                    const user = data.posts[0];
                    this.user_id = user.user_id;
                    this.social_security_number = user.social_security_number || '';
                    this.billing_first_name = user.billing_first_name || '';
                    this.billing_last_name = user.billing_last_name || '';
                    this.billing_email = user.billing_email || '';
                    this.billing_phone = user.billing_phone || '';
                    this.billing_address_1 = user.billing_address_1 || '';
                    this.billing_postcode = user.billing_postcode || '';
                    this.billing_city = user.billing_city || '';
                    this.main_member = user.main_member || '';
                    this.has_paper = typeof user.has_paper === 'number' ? user.has_paper : 1;
                    this.main_member = user.main_member || '';
                    this.familyMembers = user.family_members || [];
                    this.is_family_member = user.is_family_member || false;
                    this.has_already_paid = user.has_already_paid || false;
                    this.has_subscription = user.has_subscription || false;

                    this.errorMessage = '';
                    this.goToStep(1);
                } else {
                    this.errorMessage = 'Ingen medlem hittades med detta medlemsnummer och postnummer.';
                }
            } catch {
                this.errorMessage = 'Ett tekniskt fel uppstod. Försök igen senare.';
            } finally {
                this.isLoading = false;
            }
        },

        // ---- Step 2: update user ----
        async updateUser() {
            this.isLoading = true;
            this.errorMessage = '';
            this.socialSecurityNumberTouched = true;

            this.validateFirstName();
            this.validateLastName();
            this.validateSocialSecurityNumber();
            this.validateEmail();
            this.validatePhone();
            this.validateAddress();
            this.validateBillingPostcode();
            this.validateCity();

            if (!this.billingFirstNameValid || !this.billingLastNameValid ||
                !this.socialSecurityNumberValid || !this.billingEmailValid ||
                !this.billingPhoneValid || !this.billingAddressValid ||
                !this.billingPostcodeValid || !this.billingCityValid) {
                this.isLoading = false;
                this.billingFirstNameError =
                    !this.billingFirstNameValid
                        ? 'Förnamn är obligatoriskt'
                        : '';
                this.billingLastNameError =
                    !this.billingLastNameValid
                        ? 'Efternamn är obligatoriskt'
                        : '';
                this.socialSecurityNumberError =
                    !this.socialSecurityNumberValid
                        ? 'Felaktigt format på personnummer'
                        : '';
                this.billingEmailError =
                    !this.billingEmailValid ? 'Felaktigt format på e-post' : '';
                this.billingPhoneError =
                    !this.billingPhoneValid
                        ? 'Telefonnummer är obligatoriskt'
                        : '';
                this.billingAddressError =
                    !this.billingAddressValid ? 'Adress är obligatoriskt' : '';
                this.billingPostcodeError =
                    !this.billingPostcodeValid
                        ? 'Felaktigt format på postnummer'
                        : '';
                this.billingCityError =
                    !this.billingCityValid ? 'Ort är obligatoriskt' : '';
                return;
            }

            try {
                const response = await fetch(wpAjax.ajax_url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: new URLSearchParams({
                        action: 'update_user',
                        user_id: this.user_id,
                        billing_first_name: this.billing_first_name,
                        billing_last_name: this.billing_last_name,
                        social_security_number: this.social_security_number,
                        billing_email: this.billing_email,
                        billing_phone: this.billing_phone,
                        billing_address_1: this.billing_address_1,
                        billing_postcode: this.billing_postcode,
                        billing_city: this.billing_city,
                    }),
                });

                const data = await response.json();

                if (data.success) {
                    if (this.has_already_paid && this.is_family_member) {
                        this.dialog_family_member = true;
                    } else if (this.is_family_member) {
                        this.dialog_family_member = true;
                    } else if (this.has_already_paid) {
                        this.dialog_already_paid = true;
                    } else if (!this.has_subscription) {
                        this.dialog_no_subscription = true;
                    } else {
                        this.goToStep(2);
                    }
                } else {
                    this.errorMessage = data.message || 'Ett tekniskt fel uppstod.';
                }
            } catch {
                this.errorMessage = 'Ett tekniskt fel uppstod. Försök igen senare.';
            } finally {
                this.isLoading = false;
            }
        },

        // ---- Step 3: update membership ----
        async updateMembership() {
            this.isLoading = true;
            this.errorMessage = '';

            try {
                const response = await fetch(wpAjax.ajax_url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: new URLSearchParams({
                        action: 'update_membership',
                        nonce: wpAjax.wc_nonce,
                        user_id: this.user_id,
                        has_paper: this.has_paper,
                    }),
                });

                const data = await response.json();

                if (data.success) {
                    if (data.data && data.data.renewal_url) {
                        sessionStorage.removeItem('wizardCurrentStep');
                        sessionStorage.removeItem('wizardFormData');
                        window.location.href = data.data.renewal_url;
                    } else {
                        this.errorMessage = 'Ingen betalningslänk hittades.';
                    }
                } else {
                    this.errorMessage =
                        data.data?.message || 'Ett tekniskt fel uppstod.';
                }
            } catch {
                this.errorMessage =
                    'Ett tekniskt fel uppstod. Försök igen senare.';
            }
        },

    }));
});

//# sourceMappingURL=membership-handler.js.map
